export const DEFAULT_USER_AVATAR =
  'https://stage-trooprbucket.s3.amazonaws.com/default-user-avatar/65e713f35b8d75a374b2f692default-user-avatar.png';

export const DEFAULT_LOGO_FOR_WEBCHAT =
  'https://stage-trooprbucket.s3.amazonaws.com/copilot-logo/6540af8b85ae252feab69bc5enjo-logo.png';